import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';
import i18next from 'i18next';

export function formatDate(date, fmt = 'MM/dd/y', locale = enUS) {
  const dt = new Date(date);
  return format(dt, fmt, { locale });
}

export function formatDateTime(date) {
  const dt = new Date(date);
  return format(dt, 'MM/dd/y hh:mm aa');
}

// "12 Jun 2026 · 03:11 PM" — used in the SFH transaction history timeline.
export function formatDateTimeTimeline(date) {
  const dt = new Date(date);
  return format(dt, 'd MMM yyyy · hh:mm aa');
}

// "25 Feb 2026 · 09:14 AM" — SFH order timestamps shown exactly as the backend
// sends them. A trailing Z/offset on a string is stripped so the wall-clock
// time is displayed as-is rather than converted to the viewer's timezone.
// A Date object (e.g. a client-side "now") is formatted in local time.
export function formatSfhTimelineDate(date) {
  if (!date) return '';
  const naive =
    typeof date === 'string'
      ? date.replace(/(\.\d+)?(Z|[+-]\d{2}:?\d{2})$/, '')
      : date;
  return format(new Date(naive), 'd MMM yyyy · hh:mm aa');
}

export function getDateDay(date) {
  const dt = new Date(date);
  return format(dt, 'dd');
}

export function getDateMonth(date) {
  const dt = new Date(date);
  return format(dt, 'MM');
}

export function getDateYear(date) {
  const dt = new Date(date);
  return format(dt, 'y');
}

export function formatDateTimeLocale(date) {
  const dt = new Date(date);
  return format(dt, 'MM/dd/y hh:mm aa');
}

// TODO add locale
export function formatDateRange(dates) {
  const start = formatDate(dates.start);
  const end = formatDate(dates.end);
  return i18next.t('common.date.range', { start, end });
}

export function getDate() {
  const date = new Date();
  return { date };
}
